import Cookies from "js-cookie";
import { coordinatorAxios } from "../api/index";

export const GetToken = () => {
  const CompanyId = Cookies.get("CompanyId");
  const DepId = Cookies.get("DepId");
  const stored = JSON.parse(localStorage.getItem("CurrentCounter"));
  const currentDeptId = DepId !== undefined ? DepId : stored?.DepId;
  const getTokenURL = `token/tokenValue/${CompanyId}/${currentDeptId}`;
  try {
    const response = coordinatorAxios.get(getTokenURL, {
      headers: { Authorization: `Bearer ${Cookies.get("userToken")}` },
    });
    return response;
  } catch (error) {
    return error;
  }
};

export const GetHoldToken = () => {
  const CompanyId = Cookies.get("CompanyId");
  const UserID = Cookies.get("UserID");
  const getHoldTokenURL = `token/onHold/${CompanyId}/${UserID}`;
  try {
    const response = coordinatorAxios.get(getHoldTokenURL, {
      headers: { Authorization: `Bearer ${Cookies.get("userToken")}` },
    });
    return response;
  } catch (error) {
    return error;
  }
};

export const GetAllPendingToken = () => {
  const CompanyId = Cookies.get("CompanyId");
  const UserID = Cookies.get("UserID");
  const allPendingTokenURL = `token/onPending/${CompanyId}/${UserID}`;
  try {
    const response = coordinatorAxios.get(allPendingTokenURL, {
      headers: { Authorization: `Bearer ${Cookies.get("userToken")}` },
    });
    return response;
  } catch (error) {
    return error;
  }
};

export const GetTokenCall = (
  newDepID,
  CounterID,
  status,
  tokenValue,
  DepPrefix,
) => {
  const CompanyId = Cookies.get("CompanyId");

  const requestData = {
    CounterID: CounterID,
    DepId: newDepID,
    status: status,
    tokenValue: tokenValue || undefined,
    depPrefix: DepPrefix || Cookies.get("DepPrefix"),
    CompanyId: CompanyId,
    // Include other necessary fields from cookies if needed
    DepId: newDepID || Cookies.get("DepId"),
    CounterID: CounterID || Cookies.get("CounterID"),
  };

  // Clean up undefined values
  Object.keys(requestData).forEach((key) => {
    if (requestData[key] === undefined) {
      delete requestData[key];
    }
  });

  try {
    const response = coordinatorAxios.post(
      `token/updateTokenStatus`,
      requestData,
      {
        headers: {
          Authorization: `Bearer ${Cookies.get("userToken")}`,
          "Content-Type": "application/json",
        },
      },
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const DeleteAllToken = (DepId) => {
  const CompanyId = Cookies.get("CompanyId");
  const deleteTokenUrl = `token/resetToken/${CompanyId}/${DepId}`;
  try {
    const response = coordinatorAxios.put(
      deleteTokenUrl,
      {},
      {
        headers: { Authorization: `Bearer ${Cookies.get("userToken")}` },
      },
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const CustomTokenCall = (data) => {
  const customTokenCallUrl = "Token/updateCustomTokenStatus";

  try {
    const response = coordinatorAxios.post(customTokenCallUrl, data, {
      headers: { Authorization: `Bearer ${Cookies.get("userToken")}` },
    });
    return response;
  } catch (error) {
    return error;
  }
};

export const CompleteTokenStatus = (tokenValue, depPrefix) => {
  const CompanyId = Cookies.get("CompanyId");
  const DepId = Cookies.get("DepId");

  let getTokenCallUrl = `token/tokenStatusUpdate/${CompanyId}?depId=${DepId}&tokenValue=${tokenValue}&iscomplete=true`;

  if (depPrefix && depPrefix !== "undefined" && depPrefix !== "null") {
    getTokenCallUrl += `&depPrefix=${encodeURIComponent(depPrefix)}`;
  }

  const requestBody = {
    userId: Cookies.get("UserID"),
    serviceId: Cookies.get("ServiceID"),
    customerId: Cookies.get("CustomerID"),
    counterId: Cookies.get("CounterID"),
  };

  try {
    const response = coordinatorAxios.post(getTokenCallUrl, requestBody, {
      headers: { Authorization: `Bearer ${Cookies.get("userToken")}` },
    });
    return response;
  } catch (error) {
    return error;
  }
};

// token transfer
export const TokenTransfer = async (
  tokenValue,
  departmentid,
  serviceId,
  DepPrefix,
  DepId,
  tokenId,
) => {
  const CompanyId = Cookies.get("CompanyId");
  // const DepId = Cookies.get("DepId");

  // const DepPrefix = Cookies.get("DepPrefix");
  const counterId = String(Cookies.get("CounterID"));
  let tokenTransferUrl = `token/updateDepartment/${CompanyId}/${DepId}/${DepPrefix}/${tokenValue}`;

  const requestBody = {
    newDepId: departmentid,
    tokenId: tokenId,
    serviceId: serviceId || "0",
    counterId,
  };

  try {
    const response = await coordinatorAxios.put(tokenTransferUrl, requestBody, {
      headers: { Authorization: `Bearer ${Cookies.get("userToken")}` },
    });
    return response;
  } catch (error) {
    throw new Error(`Token transfer failed: ${error.message}`);
  }
};

export const GetDepartmentForCoordinator = () => {
  const GetDepartmentForCoordinatorURL = `department/web/${Cookies.get(
    "UserID",
  )}`;
  try {
    const response = coordinatorAxios.get(GetDepartmentForCoordinatorURL, {
      headers: {
        Authorization: `Bearer ${Cookies.get("userToken")}`,
      },
    });
    return response;
  } catch (err) {
    return err;
  }
};

// Token Recall
export const GetRecallToken = (data) => {
  const CompanyId = Cookies.get("CompanyId");
  const DepId = Cookies.get("DepId");
  const UserID = Cookies.get("UserID");
  const CounterID = Cookies.get("CounterID");
  const CoustomCallDeprefix = Cookies.get("DepPrefix");
  const GetRecallTokenURL = `token/recall`;
  const { tokenId, tokenValue, serviceId, DepPrefix } = data;
  const requestBody = {
    depId: DepId,
    companyId: CompanyId,
    tokenId: tokenId,
    userId: UserID,
    counterId: CounterID,
    tokenValue: tokenValue,
    serviceId: serviceId || 0,
    depPrefix: DepPrefix ?? CoustomCallDeprefix,
  };
  try {
    const response = coordinatorAxios.put(GetRecallTokenURL, requestBody, {
      headers: {
        Authorization: `Bearer ${Cookies.get("userToken")}`,
      },
      data: data,
    });
    return response;
  } catch (err) {
    return err;
  }
};

// ChecktokenValue
export const CheckTokenValue = (tokenValue) => {
  const CompanyId = Cookies.get("CompanyId");
  const DepId = Cookies.get("DepId");
  let CheckTokenValueURL = `token/checkToken/${CompanyId}/${DepId}/${tokenValue}`;
  try {
    const response = coordinatorAxios.get(CheckTokenValueURL, {
      headers: { Authorization: `Bearer ${Cookies.get("userToken")}` },
    });
    return response;
  } catch (error) {
    return error;
  }
};

// export const CompleteTokenStatus = (tokenValue ,) => {
//   const CompanyId = Cookies.get("CompanyId");
//   const DepId = Cookies.get("DepId");
//   let getTokenCallUrl = `token/tokenStatusUpdate/${CompanyId}/${DepId}/${tokenValue}`;
//   try {
//     const response = coordinatorAxios.get(getTokenCallUrl, {
//       headers: { Authorization: `Bearer ${Cookies.get("userToken")}` },
//     });
//     return response;
//   } catch (error) {
//     return error;
//   }
// };

export const GetSevice = () => {
  const GetAllSeviceURL = `service/${Cookies.get("CompanyId")}`;
  try {
    const response = coordinatorAxios.get(GetAllSeviceURL, {
      headers: {
        Authorization: `Bearer ${Cookies.get("userToken")}`,
      },
    });
    return response;
  } catch (err) {
    return err;
  }
};

// Get completed Token

export const GetCompleted = () => {
  const GetCompletedURL = `token/onCompleted/${Cookies.get(
    "CompanyId",
  )}/${Cookies.get("UserID")}`;
  try {
    const response = coordinatorAxios.get(GetCompletedURL, {
      headers: {
        Authorization: `Bearer ${Cookies.get("userToken")}`,
      },
    });
    return response;
  } catch (err) {
    return err;
  }
};

export const GetTimeline = (tokenId) => {
  let GetTimelineUrl = `Token/timeline/${tokenId}`;
  try {
    const response = coordinatorAxios.get(GetTimelineUrl, {
      headers: { Authorization: `Bearer ${Cookies.get("userToken")}` },
    });
    return response;
  } catch (error) {
    return error;
  }
};

export const GetDepartmentCounter = (departmentID) => {
  const GetDepartmentCounterURL = `counter/dep/${
    departmentID || Cookies.get("DepId")
  }`;
  try {
    const response = coordinatorAxios.get(GetDepartmentCounterURL, {
      headers: {
        Authorization: `Bearer ${Cookies.get("userToken")}`,
      },
    });
    return response;
  } catch (err) {
    return err;
  }
};

export const GetDepartments = () => {
  const GetDepartmentsURL = `department/web/all/${Cookies.get("CompanyId")}`;
  try {
    const response = coordinatorAxios.get(GetDepartmentsURL, {
      headers: {
        Authorization: `Bearer ${Cookies.get("userToken")}`,
      },
    });
    return response;
  } catch (err) {
    return err;
  }
};

export const HoldTokenStatus = (tokenValue, depPrefix) => {
  const CompanyId = Cookies.get("CompanyId");
  const DepId = Cookies.get("DepId");
  const CounterId = Cookies.get("CounterID");

  let getTokenCallUrl = `token/tokenStatusUpdate/${CompanyId}?depId=${DepId}&tokenValue=${tokenValue}&iscomplete=false`;

  if (depPrefix && depPrefix !== "undefined" && depPrefix !== "null") {
    getTokenCallUrl += `&depPrefix=${encodeURIComponent(depPrefix)}`;
  }

  const requestBody = {
    UserId: parseInt(Cookies.get("UserID") || 0),
    ServiceId: parseInt(Cookies.get("ServiceID") || 0),
    CustomerId: parseInt(Cookies.get("CustomerID") || 0),
    CounterId: parseInt(CounterId || 0),
  };

  try {
    const response = coordinatorAxios.post(getTokenCallUrl, requestBody, {
      headers: {
        Authorization: `Bearer ${Cookies.get("userToken")}`,
        accept: "*/*",
        "Content-Type": "application/json",
      },
    });
    return response;
  } catch (error) {
    return error;
  }
};
